export default function () {
  this.loadMessages()
}
